import i18next from "i18next";
import { initReactI18next } from "react-i18next";

import backend from "i18next-http-backend";
import fetch from "node-fetch";
import detector from "i18next-browser-languagedetector";

let ready;
let readyCallback;

i18next

    .use(backend)

    .use(detector)

    .use(initReactI18next)

    .init({
        ns: ["PrivacyMainContentWidget"],
        defaultNS: "PrivacyMainContentWidget",
        detection: {
            lookupQuerystring: "locales",
        },
        lng: "en",
        fallbackLng: "en",
        debug: false,
        interpolation: {
            escapeValue: false,
        },
        react: {
            useSuspense: false,
            wait: true,
        },
        backend: {
            ajax: fetch,
            loadPath: "/locales/{{lng}}/{{ns}}.json",
            stringify: JSON.stringify,
            parse: data => JSON.parse(data),
        },
    })
    .then(() => {
        ready = true;
        if (readyCallback) {
            readyCallback();
        }
    });

export const setCallback = callback => {
    readyCallback = callback;
    if (ready) {
        readyCallback();
    }
};

export default i18next;
